export default {
  'Account ID': 'common.field.accountID',
  'Account Name': 'common.field.accountName',
  'Bank Branch': 'common.field.bankBranch',
  'Account Number': 'common.field.accNum',
  'Bank City': 'common.field.bankCity',
  'Bank Province': 'common.field.bankProvince',
  BankName: 'common.field.bankName',
  accounttype: 'common.field.accType',
  'Fasapay Account Name': 'withdraw.fasa.field.accName',
  'Fasapay Account Number': 'withdraw.fasa.field.accNum',
  documenttype: 'withdraw.mexico.field.documenttype',
  accountdigit: 'withdraw.mexico.field.accountdigit',
  'Document ID': 'withdraw.mexico.field.documentID',
  'PIX Account Name': 'common.field.paymentAccName',
  'PIX Account Number': 'common.field.paymentAccNum',
  'Branch Code': 'common.field.bankBranchCode',
  'Bank Account Name': 'common.field.bankAccName',
  'Bank Account Number': 'common.field.bankAccNum',
  'Bank Account Name in Katakana': 'common.field.bankAccNumKate',
  BranchName: 'common.field.bankBranch',
  'SWIFT Code': 'common.field.swift',
  'Bank Name': 'common.field.bankName',
  'Bank Address': 'common.field.bankAddress',
  'Account Holder’s Address': 'common.field.bankHolderAddress',
  'Bank Beneficiary Name': 'common.field.bankBeneficiaryName',
  'Bank Account Number/IBAN': 'common.field.bankAccOrIBAN',
  'FX-IR ID': 'withdraw.fxir.field.id',
  'FX-IR Account Name': 'withdraw.fxir.field.accName',
  'FX-IR Wallet Number': 'withdraw.fxir.field.walletNumber',
  'ABA / Sort Code': 'common.field.abaSortCode',
  EVP: 'withdraw.default.evp',
  PHONE: 'withdraw.default.phone',
  'AirTM Account Name': 'common.field.airtmAccName',
  'AirTM Email Address': 'common.field.airtmEmail',
  'PerfectMoney Account ID (Please enter starting with an English letter)': 'common.field.perfectMoneyAccID',
  'PerfectMoney Account Name': 'common.field.perfectMoneyAccName',
  'Bkash Account Name': 'common.field.bkashaccountname',
  'Bkash Phone Number': 'common.field.bkashphonenumber',
  'Rocket Account Name': 'common.field.rocketaccountname',
  'Rocket Phone Number': 'common.field.rocketphonenumber',
  'Nagad Account Name': 'common.field.nagadaccountname',
  'Nagad Phone Number': 'common.field.nagadphonenumber',
  'TCPay Account Name': 'common.field.tcPayAccName',
  'TCPay Wallet Number': 'common.field.tcPayWalletNumber',
  'Crypto Address': 'withdraw.cryptoAddress',
  RecipientType: 'common.field.recipientType',
  Depositor: 'common.field.depositor',
  depositor: 'common.field.depositor',
  'Tax ID': 'common.field.taxId',
}
